// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Search Section */
.Leadmanegment_lead_search_section__KClfl {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 0 10px;
}

.Leadmanegment_lead_search_section__KClfl input {
  padding: 13px;
  width: 100%;
  max-width: 350px;
  border-radius: 15px;
  outline: none;
  box-shadow: 1px 3px 5px #dfe1e300;
  border: 1px solid #c6c6eb;
}

.Leadmanegment_Lead_multiple_button__RKUja {
  display: flex;
  gap: 10px;
}

.Leadmanegment_lead_search_section__KClfl button {
  height: 45px;
  width: 170px;
  background-color: #0356cf;
  color: #fff;
  border-radius: 50px;
  cursor: pointer;
  font-size: 18px;
  outline: none;
  border: none;
  box-shadow: 1px 3px 2px #0e65e6;
}

/* Table Wrapper */
.Leadmanegment_lead_management_table_wrapper__Zp2sk {
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
  max-height: 500px;
  overflow-y: auto;
  margin: 0 auto;
  width: 100%;
}

/* Table Styling */
.Leadmanegment_lead_management_table__NV9Ml {
  width: 100%;
  border-collapse: collapse;
  min-width: 1200px;
}

.Leadmanegment_lead_management_table__NV9Ml thead th {
  background-color: #004aad;
  color: white;
  padding: 14px 16px;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;
  border: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  /* z-index: 1; */
}

.Leadmanegment_lead_management_table__NV9Ml tbody td {
  padding: 14px 16px;
  font-size: 14px;
  color: #333;
  border: 1px solid gainsboro;
  text-align: center;
}

.Leadmanegment_lead_management_table__NV9Ml tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.Leadmanegment_lead_management_table__NV9Ml tbody tr:hover {
  background-color: #f1f7ff;
}

.Leadmanegment_lead_management_table__NV9Ml tbody td[colSpan="12"] {
  text-align: center;
  color: #666;
  font-style: italic;
  padding: 20px;
}

/* Button Styling */
.Leadmanegment_viewButton__Md46s,
.Leadmanegment_editButton__aBe6Y,
.Leadmanegment_deleteButton__CrUet,
.Leadmanegment_taskButton__CEcC6,
.Leadmanegment_NeweditButton__DtuCw,
.Leadmanegment_addExtraNeedButton__hROqR {
  padding: 8px 14px;
  border: none;
  font-size: 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  white-space: nowrap;
}

.Leadmanegment_viewButton__Md46s {
  background-color: #007bff;
  color: white;
}

.Leadmanegment_viewButton__Md46s:hover {
  background-color: #0056b3;
}

.Leadmanegment_editButton__aBe6Y,
.Leadmanegment_NeweditButton__DtuCw,
.Leadmanegment_addExtraNeedButton__hROqR {
  background-color: #28a745;
  color: white;
  margin-bottom: 3px;
}

.Leadmanegment_editButton__aBe6Y:hover,
.Leadmanegment_NeweditButton__DtuCw:hover,
.Leadmanegment_addExtraNeedButton__hROqR:hover {
  background-color: #1e7e34;
}

.Leadmanegment_deleteButton__CrUet {
  background-color: #dc3545;
  color: white;
}

.Leadmanegment_deleteButton__CrUet:hover {
  background-color: #a71d2a;
}

.Leadmanegment_disable_button__CIXt- {
  background-color: #cccccc;
  color: white;
  cursor: not-allowed;
}

.Leadmanegment_showFullDetailButton__v9Cuo {
  background-color: #17a2b8;
  color: white;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border: none;
  font-size: 12px;
  margin-bottom: 3px;
}

.Leadmanegment_showFullDetailButton__v9Cuo:hover {
  background-color: #138496;
}

.Leadmanegment_follow_up_button__PY4qJ {
  background-color: #007bff;
  color: white;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border: none;
  font-size: 12px;
}

/* Task Buttons Container */
.Leadmanegment_taskButtonsContainer__MOP3o {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  padding: 0.75rem 0;
  justify-content: center;
}

.Leadmanegment_taskButton__CEcC6 {
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.2s ease-in-out;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  min-width: 80px;
  height: 40px;
}

.Leadmanegment_taskButton__CEcC6:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.Leadmanegment_nextFollowButton__EF5ZJ {
  background-color: #3b82f6;
  color: #fff;
}

.Leadmanegment_nextFollowButton__EF5ZJ:hover {
  background-color: #2563eb;
}

.Leadmanegment_otherTaskButton__RlM4x {
  background-color: #facc15;
  color: #1a1a1a;
}

.Leadmanegment_otherTaskButton__RlM4x:hover {
  background-color: #eab308;
}

.Leadmanegment_planningButton__mMesq {
  background-color: #22c55e;
  color: #fff;
}

.Leadmanegment_planningButton__mMesq:hover {
  background-color: #16a34a;
}

.Leadmanegment_accountButton__gQVBo {
  background-color: #f97316;
  color: #fff;
}

.Leadmanegment_accountButton__gQVBo:hover {
  background-color: #ea580c;
}

/* Pagination */
.Leadmanegment_pagination__Figc4 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
}

.Leadmanegment_pagination__Figc4 button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 5px;
  font-size: 16px;
  transition: background 0.3s ease-in-out;
}

.Leadmanegment_pagination__Figc4 button:hover {
  background-color: #0056b3;
}

.Leadmanegment_pagination__Figc4 .Leadmanegment_activePage__U7r3h {
  background-color: #28a745 !important;
  font-weight: bold;
  border: 2px solid white;
}

.Leadmanegment_pagination__Figc4 .Leadmanegment_disabledButton__3I0qI {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Popup Overlay */
.Leadmanegment_popupOverlay__Yc0su {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Popup Content */
.Leadmanegment_popupContent__uNACh {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 400px;
  text-align: center;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
  height: 500px;
  overflow: auto;
}

/* Close Button */
.Leadmanegment_closeButton__1XiqQ {
  background: #ff4d4d;
  color: white;
  border: none;
  padding: 8px 15px;
  margin-top: 10px;
  cursor: pointer;
  border-radius: 5px;
}

.Leadmanegment_closeButton__1XiqQ:hover {
  background: #cc0000;
}

/* Quotation Form */
.Leadmanegment_quatationOverlay__k4hDR {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 20px;
}

.Leadmanegment_quatationPopup__Scl3j {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  position: relative;
  animation: Leadmanegment_quatationFadeIn__7vcU\\+ 0.3s ease-in-out;
}

.Leadmanegment_quatationCloseButton__GmXkd {
  position: absolute;
  top: 10px;
  right: 15px;
  border: none;
  background: none;
  font-size: 22px;
  cursor: pointer;
}

.Leadmanegment_quatationPopupTitle__BTwRg {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 15px;
}

.Leadmanegment_quatationForm__0FCfY input,
.Leadmanegment_quatationForm__0FCfY select {
  width: 100%;
  padding: 12px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.Leadmanegment_quatationSubmitButton__-IrqA {
  width: 100%;
  padding: 12px;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 18px;
  transition: background 0.3s;
}

.Leadmanegment_quatationSubmitButton__-IrqA:hover {
  background: #0056b3;
}

@keyframes Leadmanegment_quatationFadeIn__7vcU\\+ {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Follow-up Popup */
.Leadmanegment_nextfollwuppopupOverlay__oQUZy {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.Leadmanegment_nextfollwuppopupContent__zaFcO {
  background-color: #ffffff;
  padding: 2rem;
  width: 90%;
  max-width: 500px;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
}

.Leadmanegment_nextfollwuppopupTitle__NR0Eb {
  margin-bottom: 1.5rem;
  font-size: 1.6rem;
  color: #333;
  text-align: center;
}

.Leadmanegment_nextFollowupForm__AsX\\+X {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.Leadmanegment_nextFollowupForm__AsX\\+X label {
  display: flex;
  flex-direction: column;
  font-size: 0.95rem;
  font-weight: 500;
  color: #444;
}

.Leadmanegment_nextFollowupForm__AsX\\+X input,
.Leadmanegment_nextFollowupForm__AsX\\+X select {
  padding: 10px 12px;
  font-size: 1rem;
  border-radius: 8px;
  border: 1px solid #ccc;
  margin-top: 0.5rem;
  background-color: #fdfdfd;
  transition: border 0.3s ease;
}

.Leadmanegment_nextFollowupForm__AsX\\+X input:focus,
.Leadmanegment_nextFollowupForm__AsX\\+X select:focus {
  border-color: #007bff;
  outline: none;
}

.Leadmanegment_nextfollwupbuttonGroup__e863f {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.Leadmanegment_nextfollwupcloseButton__BCQhC {
  padding: 10px 20px;
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.Leadmanegment_nextfollwupcloseButton__BCQhC:hover {
  background-color: #c82333;
}

.Leadmanegment_nextfollwupsubmitButton__6mZ7x {
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.Leadmanegment_nextfollwupsubmitButton__6mZ7x:hover {
  background-color: #0056b3;
}

/* Follow-up Table */
.Leadmanegment_followup_heading__udYQ4 {
  font-size: 1.2rem;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  color: #333;
}

.Leadmanegment_followup_status__pr0gs {
  font-size: 1rem;
  margin-bottom: 1rem;
  color: #555;
}

.Leadmanegment_followup_table_container__2VPyj {
  overflow-x: auto;
}

.Leadmanegment_followup_table__QHYxk {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
  background-color: #fff;
}

.Leadmanegment_followup_table__QHYxk thead {
  background-color: #f5f5f5;
}

.Leadmanegment_followup_table__QHYxk th,
.Leadmanegment_followup_table__QHYxk td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.Leadmanegment_followup_table__QHYxk tbody tr:hover {
  background-color: #f9f9f9;
}

/* Planning Executive Popup */
.Leadmanegment_planningexecutive_name_container_overlay__mJOOQ {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Leadmanegment_planningexecutive_name_container_popup__kAGXF {
  position: relative;
  background: #ffffff;
  padding: 2rem;
  border-radius: 1rem;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.Leadmanegment_planningexecutive_name_container_closeBtn__wBeJK {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #333;
  cursor: pointer;
}

.Leadmanegment_planningexecutive_name_container_title__Kcrm3 {
  font-size: 1.25rem;
  margin-bottom: 1.25rem;
  font-weight: 600;
  color: #222;
}

.Leadmanegment_planningexecutive_name_container_select__y2d0q {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  appearance: none;
  background-color: #f9fafb;
  color: #333;
}

.Leadmanegment_planningexecutive_name_container_submitBtn__KaDxI {
  margin-top: 1.25rem;
  padding: 10px 20px;
  background-color: #1d4ed8;
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
  width: 100%;
  transition: background 0.3s ease;
}

.Leadmanegment_planningexecutive_name_container_submitBtn__KaDxI:hover {
  background-color: #2563eb;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .Leadmanegment_lead_management_table__NV9Ml thead th,
  .Leadmanegment_lead_management_table__NV9Ml tbody td {
    padding: 12px 10px;
    font-size: 13px;
  }

  .Leadmanegment_viewButton__Md46s,
  .Leadmanegment_editButton__aBe6Y,
  .Leadmanegment_deleteButton__CrUet,
  .Leadmanegment_taskButton__CEcC6,
  .Leadmanegment_NeweditButton__DtuCw,
  .Leadmanegment_addExtraNeedButton__hROqR {
    padding: 6px 10px;
    font-size: 11px;
  }

  .Leadmanegment_taskButton__CEcC6 {
    min-width: 70px;
    height: 35px;
  }

  .Leadmanegment_lead_search_section__KClfl {
    flex-direction: column;
    gap: 10px;
  }

  .Leadmanegment_lead_search_section__KClfl input,
  .Leadmanegment_lead_search_section__KClfl button {
    width: 100%;
    max-width: none;
  }

  .Leadmanegment_quatationPopup__Scl3j {
    width: 85%;
    max-width: 450px;
  }

  .Leadmanegment_planningexecutive_name_container_popup__kAGXF {
    padding: 1.5rem;
    width: 90%;
  }

  .Leadmanegment_planningexecutive_name_container_title__Kcrm3 {
    font-size: 1.1rem;
  }

  .Leadmanegment_planningexecutive_name_container_select__y2d0q {
    font-size: 0.95rem;
    padding: 0.65rem 0.9rem;
  }

  .Leadmanegment_planningexecutive_name_container_closeBtn__wBeJK {
    font-size: 1.3rem;
    top: 8px;
    right: 12px;
  }
}

@media (max-width: 768px) {
  .Leadmanegment_lead_management_table__NV9Ml thead th,
  .Leadmanegment_lead_management_table__NV9Ml tbody td {
    padding: 10px 8px;
    font-size: 12px;
  }

  .Leadmanegment_viewButton__Md46s,
  .Leadmanegment_editButton__aBe6Y,
  .Leadmanegment_deleteButton__CrUet,
  .Leadmanegment_taskButton__CEcC6,
  .Leadmanegment_NeweditButton__DtuCw,
  .Leadmanegment_addExtraNeedButton__hROqR {
    padding: 5px 8px;
    font-size: 10px;
  }

  .Leadmanegment_taskButton__CEcC6 {
    min-width: 100%;
    height: 30px;
  }

  .Leadmanegment_taskButtonsContainer__MOP3o {
    flex-direction: column;
    gap: 0.5rem;
  }

  .Leadmanegment_lead_search_section__KClfl button {
    font-size: 16px;
    height: 40px;
  }

  .Leadmanegment_quatationPopup__Scl3j {
    width: 90%;
    max-width: 400px;
    padding: 15px;
  }

  .Leadmanegment_quatationPopupTitle__BTwRg {
    font-size: 18px;
  }

  .Leadmanegment_quatationForm__0FCfY input,
  .Leadmanegment_quatationForm__0FCfY select {
    padding: 10px;
    font-size: 14px;
  }

  .Leadmanegment_quatationSubmitButton__-IrqA {
    padding: 10px;
    font-size: 16px;
  }

  .Leadmanegment_nextfollwuppopupContent__zaFcO {
    padding: 1.2rem;
  }

  .Leadmanegment_nextfollwuppopupTitle__NR0Eb {
    font-size: 1.3rem;
  }

  .Leadmanegment_nextFollowupForm__AsX\\+X input,
  .Leadmanegment_nextFollowupForm__AsX\\+X select {
    font-size: 0.95rem;
  }

  .Leadmanegment_followup_table__QHYxk th,
  .Leadmanegment_followup_table__QHYxk td {
    padding: 10px 12px;
    font-size: 0.9rem;
  }

  .Leadmanegment_planningexecutive_name_container_popup__kAGXF {
    padding: 1.5rem;
    width: 90%;
  }
}

@media (max-width: 480px) {
  .Leadmanegment_lead_management_table__NV9Ml thead th,
  .Leadmanegment_lead_management_table__NV9Ml tbody td {
    padding: 8px 6px;
    font-size: 11px;
  }

  .Leadmanegment_viewButton__Md46s,
  .Leadmanegment_editButton__aBe6Y,
  .Leadmanegment_deleteButton__CrUet,
  .Leadmanegment_taskButton__CEcC6,
  .Leadmanegment_NeweditButton__DtuCw,
  .Leadmanegment_addExtraNeedButton__hROqR {
    padding: 4px 6px;
    font-size: 9px;
  }

  .Leadmanegment_taskButton__CEcC6 {
    min-width: 100%;
    height: 28px;
  }

  .Leadmanegment_lead_search_section__KClfl input {
    padding: 10px;
    font-size: 14px;
  }

  .Leadmanegment_lead_search_section__KClfl button {
    font-size: 14px;
    height: 35px;
  }

  .Leadmanegment_pagination__Figc4 button {
    padding: 6px 10px;
    font-size: 14px;
  }

  .Leadmanegment_quatationPopup__Scl3j {
    width: 95%;
    max-width: 350px;
    padding: 15px;
  }

  .Leadmanegment_quatationPopupTitle__BTwRg {
    font-size: 16px;
  }

  .Leadmanegment_quatationForm__0FCfY input,
  .Leadmanegment_quatationForm__0FCfY select {
    padding: 8px;
    font-size: 14px;
  }

  .Leadmanegment_quatationSubmitButton__-IrqA {
    padding: 10px;
    font-size: 14px;
  }

  .Leadmanegment_quatationCloseButton__GmXkd {
    font-size: 18px;
  }

  .Leadmanegment_nextfollwupbuttonGroup__e863f {
    flex-direction: column;
  }

  .Leadmanegment_followup_heading__udYQ4 {
    font-size: 1rem;
  }

  .Leadmanegment_planningexecutive_name_container_popup__kAGXF {
    padding: 1.25rem;
  }

  .Leadmanegment_planningexecutive_name_container_title__Kcrm3 {
    font-size: 1rem;
  }

  .Leadmanegment_planningexecutive_name_container_select__y2d0q {
    font-size: 0.9rem;
    padding: 0.6rem 0.85rem;
  }

  .Leadmanegment_planningexecutive_name_container_closeBtn__wBeJK {
    font-size: 1.2rem;
  }
  .Leadmanegment_lead_table_scrrol__GZkbF {
    overflow-x: auto;
    width: 100%;
  }
}

.Leadmanegment_nextfollwuppopupOverlay__oQUZy {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.Leadmanegment_nextfollwuppopupContent__zaFcO {
  width: 500px;
  height: 80vh;          /* Fixed height */
  background: white;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
}

/* HEADER fixed */
.Leadmanegment_modalHeader__LUEnv {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f9fafc;
}

/* BODY scrollable */
.Leadmanegment_modalBody__MhWu7 {
  padding: 20px;
  overflow-y: auto;      /* 🔥 SCROLL ENABLED */
  flex: 1 1;
}

/* Smooth scrollbar */
.Leadmanegment_modalBody__MhWu7::-webkit-scrollbar {
  width: 6px;
}

.Leadmanegment_modalBody__MhWu7::-webkit-scrollbar-thumb {
  background: #1976d2;
  border-radius: 6px;
}

.Leadmanegment_progressButton__Kyoqw {
  background: #8b5cf6 !important;
  color: white !important;
  border: none !important;
  margin-left: 10px;
}

.Leadmanegment_progressButton__Kyoqw:hover {
  background: #7c3aed !important;
  transform: translateY(-1px);
}









`, "",{"version":3,"sources":["webpack://./src/styles/Leadmanegment.module.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,aAAa;EACb,YAAY;EACZ,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,mBAAmB;AACnB;;;;;;EAME,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,YAAY;EACZ,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,aAAa;EACb,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,iEAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;;;;;;IAME,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,QAAQ;IACR,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;;;;;;IAME,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;;;;;IAME,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY,WAAW,iBAAiB;EACxC,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,gBAAgB,OAAO,sBAAsB;EAC7C,SAAO;AACT;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B","sourcesContent":["/* Search Section */\n.lead_search_section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding: 0 10px;\n}\n\n.lead_search_section input {\n  padding: 13px;\n  width: 100%;\n  max-width: 350px;\n  border-radius: 15px;\n  outline: none;\n  box-shadow: 1px 3px 5px #dfe1e300;\n  border: 1px solid #c6c6eb;\n}\n\n.Lead_multiple_button {\n  display: flex;\n  gap: 10px;\n}\n\n.lead_search_section button {\n  height: 45px;\n  width: 170px;\n  background-color: #0356cf;\n  color: #fff;\n  border-radius: 50px;\n  cursor: pointer;\n  font-size: 18px;\n  outline: none;\n  border: none;\n  box-shadow: 1px 3px 2px #0e65e6;\n}\n\n/* Table Wrapper */\n.lead_management_table_wrapper {\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n  max-height: 500px;\n  overflow-y: auto;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* Table Styling */\n.lead_management_table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1200px;\n}\n\n.lead_management_table thead th {\n  background-color: #004aad;\n  color: white;\n  padding: 14px 16px;\n  font-weight: bold;\n  font-size: 14px;\n  text-transform: uppercase;\n  border: 1px solid #e0e0e0;\n  position: sticky;\n  top: 0;\n  /* z-index: 1; */\n}\n\n.lead_management_table tbody td {\n  padding: 14px 16px;\n  font-size: 14px;\n  color: #333;\n  border: 1px solid gainsboro;\n  text-align: center;\n}\n\n.lead_management_table tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.lead_management_table tbody tr:hover {\n  background-color: #f1f7ff;\n}\n\n.lead_management_table tbody td[colSpan=\"12\"] {\n  text-align: center;\n  color: #666;\n  font-style: italic;\n  padding: 20px;\n}\n\n/* Button Styling */\n.viewButton,\n.editButton,\n.deleteButton,\n.taskButton,\n.NeweditButton,\n.addExtraNeedButton {\n  padding: 8px 14px;\n  border: none;\n  font-size: 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  white-space: nowrap;\n}\n\n.viewButton {\n  background-color: #007bff;\n  color: white;\n}\n\n.viewButton:hover {\n  background-color: #0056b3;\n}\n\n.editButton,\n.NeweditButton,\n.addExtraNeedButton {\n  background-color: #28a745;\n  color: white;\n  margin-bottom: 3px;\n}\n\n.editButton:hover,\n.NeweditButton:hover,\n.addExtraNeedButton:hover {\n  background-color: #1e7e34;\n}\n\n.deleteButton {\n  background-color: #dc3545;\n  color: white;\n}\n\n.deleteButton:hover {\n  background-color: #a71d2a;\n}\n\n.disable_button {\n  background-color: #cccccc;\n  color: white;\n  cursor: not-allowed;\n}\n\n.showFullDetailButton {\n  background-color: #17a2b8;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  border: none;\n  font-size: 12px;\n  margin-bottom: 3px;\n}\n\n.showFullDetailButton:hover {\n  background-color: #138496;\n}\n\n.follow_up_button {\n  background-color: #007bff;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  border: none;\n  font-size: 12px;\n}\n\n/* Task Buttons Container */\n.taskButtonsContainer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  padding: 0.75rem 0;\n  justify-content: center;\n}\n\n.taskButton {\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 8px;\n  transition: all 0.2s ease-in-out;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  min-width: 80px;\n  height: 40px;\n}\n\n.taskButton:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n}\n\n.nextFollowButton {\n  background-color: #3b82f6;\n  color: #fff;\n}\n\n.nextFollowButton:hover {\n  background-color: #2563eb;\n}\n\n.otherTaskButton {\n  background-color: #facc15;\n  color: #1a1a1a;\n}\n\n.otherTaskButton:hover {\n  background-color: #eab308;\n}\n\n.planningButton {\n  background-color: #22c55e;\n  color: #fff;\n}\n\n.planningButton:hover {\n  background-color: #16a34a;\n}\n\n.accountButton {\n  background-color: #f97316;\n  color: #fff;\n}\n\n.accountButton:hover {\n  background-color: #ea580c;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  gap: 10px;\n}\n\n.pagination button {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 16px;\n  transition: background 0.3s ease-in-out;\n}\n\n.pagination button:hover {\n  background-color: #0056b3;\n}\n\n.pagination .activePage {\n  background-color: #28a745 !important;\n  font-weight: bold;\n  border: 2px solid white;\n}\n\n.pagination .disabledButton {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n/* Popup Overlay */\n.popupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Popup Content */\n.popupContent {\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  width: 400px;\n  text-align: center;\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);\n  height: 500px;\n  overflow: auto;\n}\n\n/* Close Button */\n.closeButton {\n  background: #ff4d4d;\n  color: white;\n  border: none;\n  padding: 8px 15px;\n  margin-top: 10px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.closeButton:hover {\n  background: #cc0000;\n}\n\n/* Quotation Form */\n.quatationOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.quatationPopup {\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  position: relative;\n  animation: quatationFadeIn 0.3s ease-in-out;\n}\n\n.quatationCloseButton {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  border: none;\n  background: none;\n  font-size: 22px;\n  cursor: pointer;\n}\n\n.quatationPopupTitle {\n  font-size: 20px;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n.quatationForm input,\n.quatationForm select {\n  width: 100%;\n  padding: 12px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n.quatationSubmitButton {\n  width: 100%;\n  padding: 12px;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 18px;\n  transition: background 0.3s;\n}\n\n.quatationSubmitButton:hover {\n  background: #0056b3;\n}\n\n@keyframes quatationFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Follow-up Popup */\n.nextfollwuppopupOverlay {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n.nextfollwuppopupContent {\n  background-color: #ffffff;\n  padding: 2rem;\n  width: 90%;\n  max-width: 500px;\n  border-radius: 12px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);\n}\n\n.nextfollwuppopupTitle {\n  margin-bottom: 1.5rem;\n  font-size: 1.6rem;\n  color: #333;\n  text-align: center;\n}\n\n.nextFollowupForm {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n\n.nextFollowupForm label {\n  display: flex;\n  flex-direction: column;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: #444;\n}\n\n.nextFollowupForm input,\n.nextFollowupForm select {\n  padding: 10px 12px;\n  font-size: 1rem;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  margin-top: 0.5rem;\n  background-color: #fdfdfd;\n  transition: border 0.3s ease;\n}\n\n.nextFollowupForm input:focus,\n.nextFollowupForm select:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.nextfollwupbuttonGroup {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.nextfollwupcloseButton {\n  padding: 10px 20px;\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.nextfollwupcloseButton:hover {\n  background-color: #c82333;\n}\n\n.nextfollwupsubmitButton {\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.nextfollwupsubmitButton:hover {\n  background-color: #0056b3;\n}\n\n/* Follow-up Table */\n.followup_heading {\n  font-size: 1.2rem;\n  margin-top: 1.5rem;\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n.followup_status {\n  font-size: 1rem;\n  margin-bottom: 1rem;\n  color: #555;\n}\n\n.followup_table_container {\n  overflow-x: auto;\n}\n\n.followup_table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.95rem;\n  background-color: #fff;\n}\n\n.followup_table thead {\n  background-color: #f5f5f5;\n}\n\n.followup_table th,\n.followup_table td {\n  padding: 12px 16px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.followup_table tbody tr:hover {\n  background-color: #f9f9f9;\n}\n\n/* Planning Executive Popup */\n.planningexecutive_name_container_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.planningexecutive_name_container_popup {\n  position: relative;\n  background: #ffffff;\n  padding: 2rem;\n  border-radius: 1rem;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.planningexecutive_name_container_closeBtn {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  color: #333;\n  cursor: pointer;\n}\n\n.planningexecutive_name_container_title {\n  font-size: 1.25rem;\n  margin-bottom: 1.25rem;\n  font-weight: 600;\n  color: #222;\n}\n\n.planningexecutive_name_container_select {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  border: 1px solid #ccc;\n  border-radius: 0.5rem;\n  appearance: none;\n  background-color: #f9fafb;\n  color: #333;\n}\n\n.planningexecutive_name_container_submitBtn {\n  margin-top: 1.25rem;\n  padding: 10px 20px;\n  background-color: #1d4ed8;\n  color: white;\n  border: none;\n  border-radius: 0.5rem;\n  font-size: 1rem;\n  cursor: pointer;\n  width: 100%;\n  transition: background 0.3s ease;\n}\n\n.planningexecutive_name_container_submitBtn:hover {\n  background-color: #2563eb;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .lead_management_table thead th,\n  .lead_management_table tbody td {\n    padding: 12px 10px;\n    font-size: 13px;\n  }\n\n  .viewButton,\n  .editButton,\n  .deleteButton,\n  .taskButton,\n  .NeweditButton,\n  .addExtraNeedButton {\n    padding: 6px 10px;\n    font-size: 11px;\n  }\n\n  .taskButton {\n    min-width: 70px;\n    height: 35px;\n  }\n\n  .lead_search_section {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .lead_search_section input,\n  .lead_search_section button {\n    width: 100%;\n    max-width: none;\n  }\n\n  .quatationPopup {\n    width: 85%;\n    max-width: 450px;\n  }\n\n  .planningexecutive_name_container_popup {\n    padding: 1.5rem;\n    width: 90%;\n  }\n\n  .planningexecutive_name_container_title {\n    font-size: 1.1rem;\n  }\n\n  .planningexecutive_name_container_select {\n    font-size: 0.95rem;\n    padding: 0.65rem 0.9rem;\n  }\n\n  .planningexecutive_name_container_closeBtn {\n    font-size: 1.3rem;\n    top: 8px;\n    right: 12px;\n  }\n}\n\n@media (max-width: 768px) {\n  .lead_management_table thead th,\n  .lead_management_table tbody td {\n    padding: 10px 8px;\n    font-size: 12px;\n  }\n\n  .viewButton,\n  .editButton,\n  .deleteButton,\n  .taskButton,\n  .NeweditButton,\n  .addExtraNeedButton {\n    padding: 5px 8px;\n    font-size: 10px;\n  }\n\n  .taskButton {\n    min-width: 100%;\n    height: 30px;\n  }\n\n  .taskButtonsContainer {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .lead_search_section button {\n    font-size: 16px;\n    height: 40px;\n  }\n\n  .quatationPopup {\n    width: 90%;\n    max-width: 400px;\n    padding: 15px;\n  }\n\n  .quatationPopupTitle {\n    font-size: 18px;\n  }\n\n  .quatationForm input,\n  .quatationForm select {\n    padding: 10px;\n    font-size: 14px;\n  }\n\n  .quatationSubmitButton {\n    padding: 10px;\n    font-size: 16px;\n  }\n\n  .nextfollwuppopupContent {\n    padding: 1.2rem;\n  }\n\n  .nextfollwuppopupTitle {\n    font-size: 1.3rem;\n  }\n\n  .nextFollowupForm input,\n  .nextFollowupForm select {\n    font-size: 0.95rem;\n  }\n\n  .followup_table th,\n  .followup_table td {\n    padding: 10px 12px;\n    font-size: 0.9rem;\n  }\n\n  .planningexecutive_name_container_popup {\n    padding: 1.5rem;\n    width: 90%;\n  }\n}\n\n@media (max-width: 480px) {\n  .lead_management_table thead th,\n  .lead_management_table tbody td {\n    padding: 8px 6px;\n    font-size: 11px;\n  }\n\n  .viewButton,\n  .editButton,\n  .deleteButton,\n  .taskButton,\n  .NeweditButton,\n  .addExtraNeedButton {\n    padding: 4px 6px;\n    font-size: 9px;\n  }\n\n  .taskButton {\n    min-width: 100%;\n    height: 28px;\n  }\n\n  .lead_search_section input {\n    padding: 10px;\n    font-size: 14px;\n  }\n\n  .lead_search_section button {\n    font-size: 14px;\n    height: 35px;\n  }\n\n  .pagination button {\n    padding: 6px 10px;\n    font-size: 14px;\n  }\n\n  .quatationPopup {\n    width: 95%;\n    max-width: 350px;\n    padding: 15px;\n  }\n\n  .quatationPopupTitle {\n    font-size: 16px;\n  }\n\n  .quatationForm input,\n  .quatationForm select {\n    padding: 8px;\n    font-size: 14px;\n  }\n\n  .quatationSubmitButton {\n    padding: 10px;\n    font-size: 14px;\n  }\n\n  .quatationCloseButton {\n    font-size: 18px;\n  }\n\n  .nextfollwupbuttonGroup {\n    flex-direction: column;\n  }\n\n  .followup_heading {\n    font-size: 1rem;\n  }\n\n  .planningexecutive_name_container_popup {\n    padding: 1.25rem;\n  }\n\n  .planningexecutive_name_container_title {\n    font-size: 1rem;\n  }\n\n  .planningexecutive_name_container_select {\n    font-size: 0.9rem;\n    padding: 0.6rem 0.85rem;\n  }\n\n  .planningexecutive_name_container_closeBtn {\n    font-size: 1.2rem;\n  }\n  .lead_table_scrrol {\n    overflow-x: auto;\n    width: 100%;\n  }\n}\n\n.nextfollwuppopupOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.nextfollwuppopupContent {\n  width: 500px;\n  height: 80vh;          /* Fixed height */\n  background: white;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n}\n\n/* HEADER fixed */\n.modalHeader {\n  padding: 15px 20px;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f9fafc;\n}\n\n/* BODY scrollable */\n.modalBody {\n  padding: 20px;\n  overflow-y: auto;      /* 🔥 SCROLL ENABLED */\n  flex: 1;\n}\n\n/* Smooth scrollbar */\n.modalBody::-webkit-scrollbar {\n  width: 6px;\n}\n\n.modalBody::-webkit-scrollbar-thumb {\n  background: #1976d2;\n  border-radius: 6px;\n}\n\n.progressButton {\n  background: #8b5cf6 !important;\n  color: white !important;\n  border: none !important;\n  margin-left: 10px;\n}\n\n.progressButton:hover {\n  background: #7c3aed !important;\n  transform: translateY(-1px);\n}\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lead_search_section": `Leadmanegment_lead_search_section__KClfl`,
	"Lead_multiple_button": `Leadmanegment_Lead_multiple_button__RKUja`,
	"lead_management_table_wrapper": `Leadmanegment_lead_management_table_wrapper__Zp2sk`,
	"lead_management_table": `Leadmanegment_lead_management_table__NV9Ml`,
	"viewButton": `Leadmanegment_viewButton__Md46s`,
	"editButton": `Leadmanegment_editButton__aBe6Y`,
	"deleteButton": `Leadmanegment_deleteButton__CrUet`,
	"taskButton": `Leadmanegment_taskButton__CEcC6`,
	"NeweditButton": `Leadmanegment_NeweditButton__DtuCw`,
	"addExtraNeedButton": `Leadmanegment_addExtraNeedButton__hROqR`,
	"disable_button": `Leadmanegment_disable_button__CIXt-`,
	"showFullDetailButton": `Leadmanegment_showFullDetailButton__v9Cuo`,
	"follow_up_button": `Leadmanegment_follow_up_button__PY4qJ`,
	"taskButtonsContainer": `Leadmanegment_taskButtonsContainer__MOP3o`,
	"nextFollowButton": `Leadmanegment_nextFollowButton__EF5ZJ`,
	"otherTaskButton": `Leadmanegment_otherTaskButton__RlM4x`,
	"planningButton": `Leadmanegment_planningButton__mMesq`,
	"accountButton": `Leadmanegment_accountButton__gQVBo`,
	"pagination": `Leadmanegment_pagination__Figc4`,
	"activePage": `Leadmanegment_activePage__U7r3h`,
	"disabledButton": `Leadmanegment_disabledButton__3I0qI`,
	"popupOverlay": `Leadmanegment_popupOverlay__Yc0su`,
	"popupContent": `Leadmanegment_popupContent__uNACh`,
	"closeButton": `Leadmanegment_closeButton__1XiqQ`,
	"quatationOverlay": `Leadmanegment_quatationOverlay__k4hDR`,
	"quatationPopup": `Leadmanegment_quatationPopup__Scl3j`,
	"quatationFadeIn": `Leadmanegment_quatationFadeIn__7vcU+`,
	"quatationCloseButton": `Leadmanegment_quatationCloseButton__GmXkd`,
	"quatationPopupTitle": `Leadmanegment_quatationPopupTitle__BTwRg`,
	"quatationForm": `Leadmanegment_quatationForm__0FCfY`,
	"quatationSubmitButton": `Leadmanegment_quatationSubmitButton__-IrqA`,
	"nextfollwuppopupOverlay": `Leadmanegment_nextfollwuppopupOverlay__oQUZy`,
	"nextfollwuppopupContent": `Leadmanegment_nextfollwuppopupContent__zaFcO`,
	"nextfollwuppopupTitle": `Leadmanegment_nextfollwuppopupTitle__NR0Eb`,
	"nextFollowupForm": `Leadmanegment_nextFollowupForm__AsX+X`,
	"nextfollwupbuttonGroup": `Leadmanegment_nextfollwupbuttonGroup__e863f`,
	"nextfollwupcloseButton": `Leadmanegment_nextfollwupcloseButton__BCQhC`,
	"nextfollwupsubmitButton": `Leadmanegment_nextfollwupsubmitButton__6mZ7x`,
	"followup_heading": `Leadmanegment_followup_heading__udYQ4`,
	"followup_status": `Leadmanegment_followup_status__pr0gs`,
	"followup_table_container": `Leadmanegment_followup_table_container__2VPyj`,
	"followup_table": `Leadmanegment_followup_table__QHYxk`,
	"planningexecutive_name_container_overlay": `Leadmanegment_planningexecutive_name_container_overlay__mJOOQ`,
	"planningexecutive_name_container_popup": `Leadmanegment_planningexecutive_name_container_popup__kAGXF`,
	"planningexecutive_name_container_closeBtn": `Leadmanegment_planningexecutive_name_container_closeBtn__wBeJK`,
	"planningexecutive_name_container_title": `Leadmanegment_planningexecutive_name_container_title__Kcrm3`,
	"planningexecutive_name_container_select": `Leadmanegment_planningexecutive_name_container_select__y2d0q`,
	"planningexecutive_name_container_submitBtn": `Leadmanegment_planningexecutive_name_container_submitBtn__KaDxI`,
	"lead_table_scrrol": `Leadmanegment_lead_table_scrrol__GZkbF`,
	"modalHeader": `Leadmanegment_modalHeader__LUEnv`,
	"modalBody": `Leadmanegment_modalBody__MhWu7`,
	"progressButton": `Leadmanegment_progressButton__Kyoqw`
};
export default ___CSS_LOADER_EXPORT___;
